// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1swvW","actionsCol":"EnrolledClinics_actionsCol__AJSDE"};